import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImageAvatarSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImageAvatarSparkle"><Path d="M11.5 3.5H3.5V20.5H20.5V12.5M6.55691 20.2059C6.94178 17.5446 9.23212 15.5 12 15.5C14.7679 15.5 17.0582 17.5446 17.4431 20.2059M15 10.5C15 12.1569 13.6569 13.5 12 13.5C10.3431 13.5 9 12.1569 9 10.5C9 8.84315 10.3431 7.5 12 7.5C13.6569 7.5 15 8.84315 15 10.5ZM18.5 2L19.6667 4.33333L22 5.5L19.6667 6.66667L18.5 9L17.3333 6.66667L15 5.5L17.3333 4.33333L18.5 2Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconImageAvatarSparkle;
